export default __webpack_public_path__ + "static/media/background_screen_document.b5c9d385.png";